import { render, staticRenderFns } from "./CollectionExchange.vue?vue&type=template&id=54d839b6&scoped=true"
import script from "./CollectionExchange.vue?vue&type=script&lang=js"
export * from "./CollectionExchange.vue?vue&type=script&lang=js"
import style0 from "./CollectionExchange.vue?vue&type=style&index=0&id=54d839b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d839b6",
  null
  
)

export default component.exports